import type { Box as BoxProps } from '$lib/types/Components/SharedTypes';

export const getBoxAttributes = ({
    box,
    isInColumn = false,
    isInMediaAnswer = false,
}: {
    box: BoxProps;
    isInColumn?: boolean;
    isInMediaAnswer?: boolean;
}): BoxProps => {
    if (!isInColumn || isInMediaAnswer) return box;

    // Is in column
    return {
        ...box,
        left: 'none',
        right: 'none',
        backgroundColor: 'transparent',
    };
};
